"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 13.462L19.538 21 21 19.538 13.462 12 21 4.462 19.538 3 12 10.538 4.462 3 3 4.462 10.538 12 3 19.538 4.462 21 12 13.462z" }), "Close");
//# sourceMappingURL=Close.js.map